// src/pages/painel/Painel.js
import React, { useEffect, useState } from "react";
import "./painel.css";
import Footer from "../../components/footer/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLightbulb } from "@fortawesome/free-solid-svg-icons";
import {
  faChevronLeft,
  faChevronRight,
  faUtensils,
  faDrumstickBite,
  faBreadSlice,
  faCheese
} from "@fortawesome/free-solid-svg-icons";

import EditarPeso from "./EditarPeso";
import "./editarpeso.css";

import AdicionarRefeicaoModal from "./componentes/AdicionarRefeicaoModal";
import ConquistaCelebracao from "./ConquistaCelebracao";

import PainelResumo from "./PainelResumo";
import PainelPlanoAviso from "./PainelPlanoAviso";
import PainelAcoesRefeicao from "./PainelAcoesRefeicao";
import PainelSugestao from "./PainelSugestao";
import PainelCaloriasDia from "./PainelCaloriasDia";
import PainelAguaDia from "./PainelAguaDia";
import PainelFloatingButtons from "./PainelFloatingButtons";
import RefeicaoModal from "./RefeicaoModal";
import ExcluirRefeicaoModal from "./ExcluirRefeicaoModal";

const API_BASE = process.env.REACT_APP_API_BASE;

const addDaysISO = (isoDate, deltaDays) => {
  const [y, m, d] = isoDate.split("-").map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  dt.setUTCDate(dt.getUTCDate() + deltaDays);
  const yy = dt.getUTCFullYear();
  const mm = String(dt.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(dt.getUTCDate()).padStart(2, "0");
  return `${yy}-${mm}-${dd}`;
};

const Painel = () => {
  const [nome, setNome] = useState("");
  const [pesoAtual, setPesoAtual] = useState(null);

  const [agua, setAgua] = useState(0);
  const [metaAgua, setMetaAgua] = useState(2000);

  const [xpPorCalculo, setXpPorCalculo] = useState(0);
  const [xpPorRefeicao, setXpPorRefeicao] = useState(0);

  const [calorias, setCalorias] = useState(0);
  const [metaCalorias, setMetaCalorias] = useState(2000);

  const [conquistas, setConquistas] = useState([]);

  const [filaConquistas, setFilaConquistas] = useState([]);

  const [macrosDia, setMacrosDia] = useState({
    proteinas: 0,
    carboidratos: 0,
    gorduras: 0,
  });

  const buscarNovasConquistas = async () => {
    try {
      const res = await fetch(`${API_BASE}/conquistas-verificar.php`, {
        credentials: "include",
      });
      const data = await res.json();

      if (
        data.status === "sucesso" &&
        Array.isArray(data.novas_conquistas) &&
        data.novas_conquistas.length > 0
      ) {
        setFilaConquistas((prev) => [...prev, ...data.novas_conquistas]);
        buscarConquistas();
      }
    } catch {}
  };

  const [refeicoesDia, setRefeicoesDia] = useState([]);

  const [inputAgua, setInputAgua] = useState("");
  const [mostrarModalPeso, setMostrarModalPeso] = useState(false);
  const [mostrarModalRefeicao, setMostrarModalRefeicao] = useState(false);
  const [prefillRefeicao, setPrefillRefeicao] = useState(null);

  const [refeicaoSelecionada, setRefeicaoSelecionada] = useState(null);
  const [mostrarModalRefeicaoDetalhes, setMostrarModalRefeicaoDetalhes] =
    useState(false);

  const [refeicaoParaExcluir, setRefeicaoParaExcluir] = useState(null);
  const [mostrarModalExcluirRefeicao, setMostrarModalExcluirRefeicao] =
    useState(false);

  const [alturaCm, setAlturaCm] = useState(null);
  const [objetivo, setObjetivo] = useState("");
  const [nivelAtividade, setNivelAtividade] = useState("");
  const [idade, setIdade] = useState(null);
  const [imc, setImc] = useState(null);

  const [saldoMoedas, setSaldoMoedas] = useState(0);
  const [xpTotal, setXpTotal] = useState(0);
  const [nivel, setNivel] = useState(1);
  const [custoMoedasPorCalculo, setCustoMoedasPorCalculo] = useState(2);
  const [mostrarAnuncio, setMostrarAnuncio] = useState(true);

  const [mostrarSugestoes, setMostrarSugestoes] = useState(true);

  const [celebracaoConquista, setCelebracaoConquista] = useState(null);

  const [hoje, setHoje] = useState("");
  const [dataSelecionada, setDataSelecionada] = useState("");
  const [editandoData, setEditandoData] = useState(true);
  const [dataCadastro, setDataCadastro] = useState(null);

  const formatarDataBonita = (iso) => {
    const meses = [
      "janeiro", "fevereiro", "março", "abril", "maio", "junho",
      "julho", "agosto", "setembro", "outubro", "novembro", "dezembro",
    ];
    const [ano, mes, dia] = iso.split("-");
    return `${dia} de ${meses[parseInt(mes) - 1]} de ${ano}`;
  };

  const irParaOntem = () => {
    if (!dataCadastro) return;
    if (!dataSelecionada) return;

    const novaData = addDaysISO(dataSelecionada, -1);

    if (novaData < dataCadastro) return;
    setDataSelecionada(novaData);
  };

  const irParaAmanha = () => {
    if (!dataSelecionada) return;
    if (!hoje) return;

    if (dataSelecionada === hoje) return;

    const nova = addDaysISO(dataSelecionada, 1);
    if (nova > hoje) return;

    setDataSelecionada(nova);
  };

  const onCalculoRealizado = async () => {
    await buscarDadosUsuario();
    window.dispatchEvent(new Event("saldo-moedas-atualizado"));
  };

  const onRefeicaoSalvaComSucesso = async (novasConquistasDoSalvar = []) => {
    await buscarCalorias();
    await buscarDadosUsuario();

    if (novasConquistasDoSalvar.length > 0) {
      setFilaConquistas((prev) => [...prev, ...novasConquistasDoSalvar]);
      buscarConquistas();
    }

    await buscarNovasConquistas();
    window.dispatchEvent(new Event("saldo-moedas-atualizado"));
  };

  const onFecharCelebracao = async () => {
    setCelebracaoConquista(null);
    await buscarDadosUsuario();
    window.dispatchEvent(new Event("saldo-moedas-atualizado"));
  };

  const buscarDadosUsuario = async () => {
    try {
      const res = await fetch(`${API_BASE}/painel-dados.php`, {
        credentials: "include",
      });

      const data = await res.json();

      if (data.status === "erro") {
        window.location.href = "/login";
        return;
      }

      if (data.status === "sucesso") {
        setNome(data.nome);
        setMetaAgua(data.meta_agua);
        setMetaCalorias(data.meta_calorias);
        setPesoAtual(data.peso_atual);

        setAlturaCm(data.altura_cm ?? null);
        setObjetivo(data.objetivo || "");
        setNivelAtividade(data.nivel_atividade || "");
        setIdade(data.idade ?? null);
        setImc(data.imc ?? null);

        setSaldoMoedas(data.saldo_moedas ?? 0);
        setXpTotal(data.xp_total ?? 0);
        setNivel(data.nivel ?? 1);
        setCustoMoedasPorCalculo(data.custo_moedas_por_calculo ?? 2);
        setXpPorCalculo(data.xp_por_calculo ?? 0);
        setXpPorRefeicao(data.xp_por_refeicao ?? 0);
        setMostrarAnuncio(!!data.mostrar_anuncio);

        setMostrarSugestoes(
          data.mostrar_sugestoes !== undefined ? !!data.mostrar_sugestoes : true
        );

        setDataCadastro(data.data_cadastro);

        const hojeBackend = data.data_hoje || "";
        if (hojeBackend) {
          setHoje(hojeBackend);
          setDataSelecionada((prev) => (prev ? prev : hojeBackend));
        }
      }
    } catch {}
  };

  const alternarMostrarSugestoes = async () => {
    const novoValor = !mostrarSugestoes;
    setMostrarSugestoes(novoValor);

    try {
      const res = await fetch(`${API_BASE}/atualizar-perfil.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ mostrar_sugestoes: novoValor }),
      });

      const data = await res.json();

      if (data.status !== "sucesso") {
        setMostrarSugestoes(!novoValor);
      }
    } catch {
      setMostrarSugestoes(!novoValor);
    }
  };

  const buscarAgua = async () => {
    try {
      if (!dataSelecionada) return;

      const res = await fetch(
        `${API_BASE}/get-agua-hoje.php?data=${dataSelecionada}`,
        { credentials: "include" }
      );
      const data = await res.json();

      if (data.status === "sucesso") {
        setAgua(data.agua_consumida);
        setMetaAgua(data.meta_agua);
      }
    } catch {}
  };

  const buscarCalorias = async () => {
    try {
      if (!dataSelecionada) return;

      const res = await fetch(
        `${API_BASE}/get-calorias-hoje.php?data=${dataSelecionada}`,
        { credentials: "include" }
      );
      const data = await res.json();

      if (data.status === "sucesso") {
        setCalorias(data.calorias_consumidas);
        setMetaCalorias(data.meta_calorias);

        if (data.macros_dia) {
          setMacrosDia({
            proteinas: Number(data.macros_dia.proteinas || 0),
            carboidratos: Number(data.macros_dia.carboidratos || 0),
            gorduras: Number(data.macros_dia.gorduras || 0),
          });
        }

        setRefeicoesDia(Array.isArray(data.refeicoes) ? data.refeicoes : []);
      }
    } catch {}
  };

  const abrirDetalhesRefeicao = (refeicao) => {
    if (!refeicao) return;
    setRefeicaoSelecionada(refeicao);
    setMostrarModalRefeicaoDetalhes(true);
  };

  const abrirModalExcluirRefeicao = (refeicao) => {
    if (!refeicao) return;
    setRefeicaoParaExcluir(refeicao);
    setMostrarModalExcluirRefeicao(true);
  };

  const confirmarExclusaoRefeicao = async (refeicaoParam) => {
    const alvo = refeicaoParam || refeicaoParaExcluir;
    if (!alvo?.id) return;

    try {
      const res = await fetch(`${API_BASE}/deletar-refeicao.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ refeicao_id: alvo.id }),
      });

      const data = await res.json();

      if (data.status === "sucesso") {
        setMostrarModalExcluirRefeicao(false);
        setRefeicaoParaExcluir(null);
        buscarCalorias();
      }
    } catch {}
  };

  const handleRegistrarSugestao = (payload) => {
    setPrefillRefeicao(payload);
    setMostrarModalRefeicao(true);
  };

  const buscarConquistas = async () => {
    try {
      const res = await fetch(`${API_BASE}/conquistas-listar.php`, {
        credentials: "include",
      });
      const data = await res.json();
      if (data.status === "sucesso") setConquistas(data.conquistas);
    } catch {}
  };

  const registrarAgua = async (quantidade) => {
    if (!quantidade || isNaN(quantidade)) return;

    try {
      const res = await fetch(`${API_BASE}/adicionar-agua.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ quantidade: Number(quantidade) }),
      });

      const data = await res.json();

      if (data.status === "sucesso") {
        setInputAgua("");
        buscarAgua();

        if (data.conquista_desbloqueada) {
          setCelebracaoConquista({
            titulo: data.conquista_desbloqueada.titulo,
            descricao: data.conquista_desbloqueada.descricao,
            imagem_url: data.conquista_desbloqueada.imagem_url,
            recompensa_moedas: data.conquista_desbloqueada.recompensa_moedas ?? 0,
          });
          return;
        }
      }
    } catch {}
  };

  useEffect(() => {
    buscarDadosUsuario();
    buscarConquistas();
    buscarNovasConquistas();
  }, []);

  useEffect(() => {
    if (!celebracaoConquista && filaConquistas.length > 0) {
      const [proxima, ...resto] = filaConquistas;
      setCelebracaoConquista({
        titulo: proxima.titulo,
        descricao: proxima.descricao,
        imagem_url: proxima.imagem_url,
        recompensa_moedas: proxima.recompensa_moedas ?? 0,
      });
      setFilaConquistas(resto);
    }
  }, [celebracaoConquista, filaConquistas]);

  useEffect(() => {
    buscarAgua();
    buscarCalorias();
  }, [dataSelecionada]);

  useEffect(() => {
    if (
      typeof pesoAtual !== "number" ||
      typeof alturaCm !== "number" ||
      pesoAtual <= 0 ||
      alturaCm <= 0
    ) {
      return;
    }

    const alturaMetros = alturaCm / 100;
    const novoImc = pesoAtual / (alturaMetros * alturaMetros);

    setImc(Number(novoImc.toFixed(2)));
  }, [pesoAtual, alturaCm]);

  const progressoAgua = Math.min(
    metaAgua > 0 ? (agua / metaAgua) * 100 : 0,
    100
  ).toFixed(0);

  const progressoCalorias = Math.min(
    metaCalorias > 0 ? (calorias / metaCalorias) * 100 : 0,
    100
  ).toFixed(0);

  const isHoje = Boolean(
    dataSelecionada &&
    hoje &&
    dataSelecionada === hoje
  );

  // 🆕 o botão/modal de refeição NÃO depende mais de saldo — sempre disponível
  // (favoritos/sugestões são grátis; só o cálculo de IA, lá dentro do modal, checa saldo)

  return (
    <div className="painel-container">
      <img src="/assets/logo2.png" alt="Logo" className="painel-logo" />

      {mostrarAnuncio && (
        <div className="painel-ad-slot" style={{ textAlign: "center", margin: "8px 0" }}>
          <div style={{ width: 300, height: 250, margin: "0 auto", background: "#eee", display: "flex", alignItems: "center", justifyContent: "center", color: "#999" }}>
            Anúncio
          </div>
        </div>
      )}

      <PainelResumo
        nome={nome}
        dataCadastro={dataCadastro}
        xpTotal={xpTotal}
        nivel={nivel}
        labelObjetivo={
          objetivo === "emagrecer"
            ? "Emagrecer"
            : objetivo === "manter"
            ? "Manter o peso"
            : objetivo === "ganhar_peso" || objetivo === "ganhar_massa"
            ? "Ganhar peso"
            : ""
        }
        labelNivelAtividade={
          nivelAtividade === "sedentario"
            ? "Sedentário"
            : nivelAtividade === "leve"
            ? "Leve (1–2x/semana)"
            : nivelAtividade === "moderado"
            ? "Moderado (3–4x/semana)"
            : nivelAtividade === "ativo" || nivelAtividade === "intenso"
            ? "Intenso (5+x/semana)"
            : ""
        }
      />

      {isHoje && (
        <div className="painel-sugestao-wrapper">
          <div className="painel-sugestao-toggle-linha">
            <span className="painel-sugestao-toggle-label">
              <FontAwesomeIcon icon={faLightbulb} /> Sugestões de refeição
            </span>

            <button
              type="button"
              className={`painel-sugestao-switch ${mostrarSugestoes ? "ligado" : ""}`}
              onClick={alternarMostrarSugestoes}
              title={mostrarSugestoes ? "Ocultar sugestões" : "Mostrar sugestões"}
            >
              <span className="painel-sugestao-switch-bola" />
            </button>
          </div>

          {mostrarSugestoes && (
            <PainelSugestao onRegistrar={handleRegistrarSugestao} />
          )}
        </div>
      )}

      <div className="painel-seletor-data">
        <button
          onClick={irParaOntem}
          className="seta-data"
          disabled={!dataCadastro || !dataSelecionada || dataSelecionada <= dataCadastro}
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>

        {!editandoData ? (
          <span className="data-exibida" onClick={() => setEditandoData(true)}>
            {dataSelecionada ? formatarDataBonita(dataSelecionada) : ""}
          </span>
        ) : (
          <input
            type="date"
            value={dataSelecionada || ""}
            min={dataCadastro || ""}
            max={hoje || ""}
            onChange={(e) => setDataSelecionada(e.target.value)}
            className="input-data"
          />
        )}

        <button
          onClick={irParaAmanha}
          disabled={!dataSelecionada || !hoje || dataSelecionada === hoje}
          className="seta-data"
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </button>
      </div>

      <div className="painel-metas">
        <PainelCaloriasDia
          calorias={calorias}
          metaCalorias={metaCalorias}
          progressoCalorias={progressoCalorias}
          macrosDia={macrosDia}
          onAbrirModalRefeicao={() => setMostrarModalRefeicao(true)}
          permiteEditarRefeicao={true}
          mostrarBotaoRefeicao={isHoje}
          possuiMacros={
            macrosDia.proteinas > 0 ||
            macrosDia.carboidratos > 0 ||
            macrosDia.gorduras > 0
          }
          refeicoesDia={refeicoesDia}
          obterNomeRefeicao={(id) =>
            id === 1
              ? "Café da manhã"
              : id === 2
              ? "Almoço"
              : id === 3
              ? "Jantar"
              : id === 4
              ? "Lanche"
              : "Refeição"
          }
          obterIconeRefeicao={(id) =>
            id === 1 ? (
              <FontAwesomeIcon icon={faDrumstickBite} />
            ) : id === 2 ? (
              <FontAwesomeIcon icon={faUtensils} />
            ) : id === 3 ? (
              <FontAwesomeIcon icon={faBreadSlice} />
            ) : id === 4 ? (
              <FontAwesomeIcon icon={faCheese} />
            ) : (
              <FontAwesomeIcon icon={faUtensils} />
            )
          }
          onCliqueRefeicao={abrirDetalhesRefeicao}
          onCliqueExcluir={abrirModalExcluirRefeicao}
          dataSelecionada={dataSelecionada}
        />

        <PainelAguaDia
          agua={agua}
          metaAgua={metaAgua}
          progressoAgua={progressoAgua}
          inputAgua={inputAgua}
          setInputAgua={setInputAgua}
          registrarAgua={registrarAgua}
          botoesDesativados={false}
          dataSelecionada={dataSelecionada}
          mostrarBotoes={!!dataSelecionada && !!hoje && dataSelecionada === hoje}
        />
      </div>

      <PainelFloatingButtons />

      {mostrarModalPeso && (
        <EditarPeso
          pesoAtual={pesoAtual}
          setPesoAtual={setPesoAtual}
          onClose={() => setMostrarModalPeso(false)}
        />
      )}

      {mostrarModalRefeicao && (
        <AdicionarRefeicaoModal
          prefill={prefillRefeicao}
          onClose={() => {
            setMostrarModalRefeicao(false);
            setPrefillRefeicao(null);
          }}
          atualizarCalorias={buscarCalorias}
          onRefeicaoSalva={onRefeicaoSalvaComSucesso}
          saldoMoedas={saldoMoedas}
          custoMoedasPorCalculo={custoMoedasPorCalculo}
          xpPorCalculo={xpPorCalculo}
          xpPorRefeicao={xpPorRefeicao}
          onCalculoRealizado={onCalculoRealizado}
        />
      )}

      {celebracaoConquista && (
        <ConquistaCelebracao
          aberta={true}
          conquista={celebracaoConquista}
          nomeUsuario={nome}
          onClose={onFecharCelebracao}
        />
      )}

      {mostrarModalRefeicaoDetalhes && refeicaoSelecionada && (
        <RefeicaoModal
          refeicao={refeicaoSelecionada}
          onClose={() => {
            setMostrarModalRefeicaoDetalhes(false);
            setRefeicaoSelecionada(null);
          }}
        />
      )}

      {mostrarModalExcluirRefeicao && refeicaoParaExcluir && (
        <ExcluirRefeicaoModal
          refeicao={refeicaoParaExcluir}
          onClose={() => {
            setMostrarModalExcluirRefeicao(false);
            setRefeicaoParaExcluir(null);
          }}
          onConfirm={confirmarExclusaoRefeicao}
        />
      )}

      <Footer />
    </div>
  );
};

export default Painel;